import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const ScClockUTC = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
`;
